import * as XLSX from "xlsx";
function getGroupTableData(headers, items) {
    const rows = [];
    items.forEach((rowData) => {
        const row = {};
        headers.forEach((header) => {
            row[header.text] = rowData[header.value];
        });
        rows.push(row);
        if (rowData.belong_data) {
            rowData.belong_data.forEach((innerData) => {
                const innerRow = {};
                headers.forEach((header) => {
                    innerRow[header.text] = innerData[header.value];
                });
                rows.push(innerRow);
                if (innerData.belong_data) {
                    innerData.belong_data.forEach((innerBelongData) => {
                        const deepRow = {};
                        headers.forEach((header) => {
                            deepRow[header.text] = innerBelongData[header.value];
                        });
                        rows.push(deepRow);
                    });
                }
            });
        }
    });
    return rows;
}
export function downloadTable(headers, items, fileName = "data") {
    const tableData = getGroupTableData(headers, items);
    const ws = XLSX.utils.json_to_sheet(tableData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
}
